import { components } from "@api/api";
import { Dispatch } from "react";
import { AllRestaurants } from "@apiHooks/useRestaurants";

export type TooltipItem = components['schemas']['Tooltip'];
export type FilterWord = components['schemas']['FilterWord'];
export type FilterItem = components["schemas"]["MainInputFilterItem"];
export type FilterItemExtended = components["schemas"]["FilterItemExtended"];
export type FilterOutput = components["schemas"]["MainOutputFilter"];
export type FilterInput = components["schemas"]["MainInputFilter"];
export type IdNameItem = components["schemas"]["IdNameItem"];
export type RestaurantFilter = components["schemas"]["MainInputRestaurantFilter"];
export type OtherFilter = components["schemas"]["MainInputOtherFilter"];
export type MenuPartItem = components["schemas"]["MainInputMenuPartItem"]
export type MenuPartItemOutput = components["schemas"]["AdminMenuPartItem"] &
    { menuItemTypes?: FilterItemExtended[] | null };
export type TagCategoryItem = { id: number; title: string };
export type TagItem = { id: number; title: string; categoryId: number };
export type FilterWithChecked<T> = (T & {
    isChecked: boolean;
})
export type FiltersWithChecked<T> = FilterWithChecked<T>[]
type FilterItemWithChecked = FiltersWithChecked<FilterItem>
export type FilterValues = {
    activeRestaurantListId: number;
    venues: {
        segments: FilterItemWithChecked;
        regions: FilterItemWithChecked;
        cuisines: FiltersWithChecked<FilterItemExtended>;
        hostedLocations: FilterItemWithChecked;
        restaurants: FilterItem[];
        minUnits: number | null;
        maxUnits: number | null;
    };
    menuItems: {
        appetizers: FilterItemWithChecked;
        entrees: FilterItemWithChecked;
        sides: FilterItemWithChecked;
        desserts: FilterItemWithChecked;
        beverages: FilterItemWithChecked;
        words: FilterWord[];
        minPrice: number | null;
        maxPrice: number | null;
    };
    attributes: {
        dayParts: FilterItemWithChecked;
        ethnicSpeciality: FilterItemWithChecked;
        healthyTerms: boolean;
        smallPlates: boolean;
        kidMenus: boolean;
        glutenFree: boolean;
        plantBased: boolean;
        catering: boolean | null; // null = all items, true = catering only, false = regular only
        tags: number[];
    };
};
export type SelectFiltersContextType = {
    activeRestaurantListId: number;
    setActiveRestaurantList: (id: number, apiFiltersValues?: FilterInput) => void;
    filters: FilterValues;
    initialFilterValues: FilterValues;
    setPartial: Dispatch<Partial<FilterValues>>;
    resetFilters: () => void;
    isLoadingFilters: boolean;
    isFiltersPopupShown: boolean;
    openFiltersPopup: () => void;
    closeFiltersPopup: () => void;
    filtersText: string;
    countryCode: string;
    currentCurrency: string;
    restaurants: AllRestaurants;
    tooltipsData: TooltipItem[];
    tags: TagItem[];
    tagCategories: TagCategoryItem[];
    keywords: FilterWord[];
}
export type FilterSection = 'venues' | 'menuItems' | 'attributes';
export type CheckableItem = { id?: number; groupId?: number; isChecked: boolean };

export const defaultFilterValues: FilterValues = {
    activeRestaurantListId: 0,
    venues: {
        segments: [],
        regions: [],
        cuisines: [],
        hostedLocations: [],
        restaurants: [],
        minUnits: null,
        maxUnits: null,
    },
    menuItems: {
        appetizers: [],
        entrees: [],
        sides: [],
        desserts: [],
        beverages: [],
        words: [],
        minPrice: null,
        maxPrice: null,
    },
    attributes: {
        dayParts: [],
        ethnicSpeciality: [],
        healthyTerms: false,
        smallPlates: false,
        kidMenus: false,
        glutenFree: false,
        plantBased: false,
        catering: false,
        tags: [],
    },
};